var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewLinkedin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_936_6226)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1292 0H5.87082C2.62846 0 0 2.64063 0 5.89801V20.102C0 23.3594 2.62846 26 5.87082 26H20.1292C23.3715 26 26 23.3594 26 20.102V5.89801C26 2.64063 23.3715 0 20.1292 0Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4085 10.0781H13.6935V11.7698H13.7413C14.1988 10.9454 15.3175 10.0781 16.9857 10.0781C20.4545 10.0781 21.0959 12.2468 21.0959 15.068V21.0328H17.6702L17.6697 15.7205C17.6697 14.5058 17.6448 12.9427 15.8883 12.9427C14.1049 12.9427 13.8312 14.2645 13.8312 15.6322V21.0328H10.4085V10.0781ZM8.46713 6.75743C8.46713 7.74511 7.66885 8.54708 6.68572 8.54708C5.70209 8.54708 4.90381 7.74511 4.90381 6.75743C4.90381 5.76924 5.70209 4.96777 6.68572 4.96777C7.66885 4.96777 8.46713 5.76924 8.46713 6.75743ZM4.90381 10.0781H8.46713V21.0328H4.90381V10.0781Z",
    fill: "#18112F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_936_6226"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewLinkedin);
export default __webpack_public_path__ + "static/media/newLinkedin.bc4af07f547c1ef510b86e1af59e7146.svg";
export { ForwardRef as ReactComponent };